// Names drift between plans by punctuation, symbols and line breaks
// ("Bewegungsmelder 360, AP" vs "Bewegungsmelder 360°, AP"), so matching strips
// them — except between two digits, where the separator is meaning, not drift
// ("NYM-J 5x2,5" is a different cable from "NYM-J 5x25").
export const normalizeTypeName = (name: string): string => {
  const normalized = name
    .normalize("NFKD")
    .toLowerCase()
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9]+/g, (separator, offset: number, source: string) => {
      const previousCharacter = source[offset - 1] ?? "";
      const nextCharacter = source[offset + separator.length] ?? "";
      const isBetweenDigits =
        previousCharacter >= "0" &&
        previousCharacter <= "9" &&
        nextCharacter >= "0" &&
        nextCharacter <= "9";

      return isBetweenDigits ? "." : "";
    });

  return normalized || name.trim().toLowerCase();
};
